import { render, staticRenderFns } from "./ProjectsItem.vue?vue&type=template&id=6d2940dc&scoped=true&"
import script from "./ProjectsItem.vue?vue&type=script&lang=js&"
export * from "./ProjectsItem.vue?vue&type=script&lang=js&"
import style1 from "./ProjectsItem.vue?vue&type=style&index=1&id=6d2940dc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2940dc",
  null
  
)

export default component.exports